export enum DashboardEditFormField {
  Types = 'types',
}
